import { CSSProperties } from "react"
import { FunnelZone } from "models/opportunity-dashboard"
import { compactMoney } from "./format"

interface ZoneCardProps {
    tone: "blue" | "yellow" | "green"
    title: string
    description?: string
    zone: FunnelZone
    style?: CSSProperties
}

// One funnel zone in the Stages column: coloured header, description, and the value of its
// opportunities against the goal from Department KPIs (Green has no goal).
const ZoneCard = ({ tone, title, description, zone, style }: ZoneCardProps) => (
    <div className={`zone-card zone-card-${tone}`} style={style}>
        <div className="zone-card-header">{title}</div>
        <div className="zone-card-body">
            {description && <p className="zone-card-description">{description}</p>}
            {zone.goal !== null
                ? <div className="zone-card-value">
                    Value: {zone.count} opportunit{zone.count === 1 ? "y" : "ies"}
                    <br />@ {compactMoney(zone.value)} / {compactMoney(zone.goal)}
                </div>
                : <div className="zone-card-value zone-card-value-lg">Value: {compactMoney(zone.value)}</div>}
        </div>
    </div>
)

export default ZoneCard
